<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'materialArticleAdd',
})
</script>
<template>
  <ArticleForm />
</template>

<script setup lang="ts" name="materialArticleAdd">
import ArticleForm from './form.vue'
</script>
